module.exports = {
  MY_ACCOUNT: 'My Account',
  MY_TEAM: 'My Team',
  WHATSNEW: "What's New",
  MY_PLAN: 'My Plan',
  UPGRADE_PLAN: 'Upgrade Plan',
  PAYMENT: 'Payment',
  PRESENTATION_APP: 'Presenter App',
  PRESENTATION_LIST: 'Presentation List',
  PRESENTATION_EDITOR: 'Presentation Editor',
  PRESENTATION_BACKSTAGE: 'Presentation Backstage',
  PRESENTING_MODE: 'Presenting Mode',
  PRESENTER_REGISTER: 'Presenter Register',
  PRESENTER_LOGIN: 'Presenter Login',
  PRESENTER_FORGOTPASSWORD: 'Presenter Forgot Password',
  TEMPLATE_LIBRARY: 'Template library',
  SHARE_WITH_ME: 'Shared with Me',
  REFER_FRIEND: 'Refer a Friend',
  CATEGORY_PUBLIC_TEMPLATE_DEMO_MODE: 'Public Template > Demo mode',
  CATEGORY_PUBLIC_TEMPLATE_LISTING: 'Public Template Listing',
}
